import { commonConstants } from '../_constants';
import { initialState } from '../_helpers';

export function ftpCredentials(state=initialState.ftpCredentials, action) {
     switch (action.type) {
        case commonConstants.FTP_CREDENTIALS_SUCCESS:
            return Object.assign({}, state, action.ftpCredentials);
        default:
          return state
      }
}


// WEBPACK FOOTER //
// ./src/_reducers/ftpCredentials.reducer.js